import ScrollReveal from 'scrollreveal'

$(function () {
   ScrollReveal().reveal($('.js-animated'));
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/scrollReveal.js
// module id = 13
// module chunks = 0